import { OrgRoles } from '@/const';

export default [
    {
        path: '/cabinet',
        component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/Cabinet'),
        children: [
            {
                path: '/',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/CabinetHome.vue'),
                name: 'CabinetHome',
                meta: { requiresAuth: true }
            },
            {
                path: 'ktru/favorites',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/ktru/favorites/cabinet-ktru-favorites-list.vue'),
                name: 'CabinetKtruFavoritesList',
                meta: { requiresAuth: true }
            },
            {
                path: 'ktru/requests',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/ktru/requests/cabinet-ktru-requests-list.vue'),
                name: 'CabinetKtruRequestsList',
                meta: { requiresAuth: true }
            },
            {
                path: 'ktru/requests/create',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/ktru/requests/cabinet-ktru-request-create.vue'),
                name: 'CabinetKtruRequestsCreate',
                meta: { requiresAuth: true }
            },
            {
                path: 'ktru/requests/:id',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/ktru/requests/cabinet-ktru-request-create.vue'),
                name: 'CabinetKtruRequestsEdit',
                meta: { requiresAuth: true }
            },
            {
                path: 'notifications',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/notifications/cabinet-notifications-list.vue'),
                name: 'CabinetNotificationsList',
                meta: { requiresAuth: true }
            },
            {
                path: 'notifications/settings',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/notifications/cabinet-notifications-settings.vue'),
                name: 'CabinetNotificationSettings',
                meta: { requiresAuth: true }
            },
            {
                path: 'notifications/:id/show',
                component: () => import(/* webpackChunkName: "main" */ '@/components/cabinet/notifications/cabinet-notification-show.vue'),
                name: 'CabinetNotificationShow',
                meta: { requiresAuth: true }
            },
            {
                path: 'organization/users',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/organization/users/UsersList'),
                name: 'CabinetUsersList',
                meta: { requiresAuth: true }
            },
            {
                path: 'organization/users/create',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/organization/users/UserCreate'),
                name: 'CabinetUserCreate',
                meta: { requiresAuth: true }
            },
            {
                path: 'organization/users/:id',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/organization/users/UserEdit'),
                name: 'CabinetUserEdit',
                meta: { requiresAuth: true }
            },
            {
                path: 'user_profile',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/organization/cabinet-user-profile.vue'),
                name: 'CabinetUserProfile',
                meta: { requiresAuth: true }
            },
            {
                path: 'change_cert',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/organization/cabinet-user-change-certificate.vue'),
                name: 'CabinetUserChangeCertificate',
                meta: { requiresAuth: true }
            },
            {
                path: 'organization/profile',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/organization/cabinet-organization-profile.vue'),
                name: 'CabinetOrganizationProfile',
                meta: { requiresAuth: true }
            },
            {
                path: 'accounting',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/accounting/cabinet-accounting.vue'),
                name: 'CabinetAccounting',
                meta: { requiresAuth: true }
            },
            {
                path: 'accounting/refund_request_create',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/accounting/cabinet-accounting-refund-request-create.vue'),
                name: 'CabinetAccountingRefundRequestsCreate',
                meta: { requiresAuth: true }
            },
            {
                path: 'accounting/reconciliation_reports',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/accounting/cabinet-accounting-reconciliation-reports.vue'),
                name: 'CabinetAccountingReconciliationReports',
                meta: { requiresAuth: true }
            },
            {
                path: 'fl44/notices',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/fl44/cabinet-fl44-notices-list.vue'),
                name: 'CabinetFl44NoticesList',
                meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_FL44 }
            },
            {
                path: 'fl44/block_requests',
                component: () => import(/* webpackChunkName: "main" */ '@/components/cabinet/fl44/block-requests/cabinet-fl44-block-requests-list.vue'),
                name: 'CabinetFl44BlockRequests',
                meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_FL44 }
            },
            {
                path: 'fl44/contracts',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/fl44/cabinet-fl44-contracts-list.vue'),
                name: 'CabinetFl44ContractsList',
                meta: { requiresAuth: true }
            },
            {
                path: 'fl44/proposals',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/fl44/cabinet-fl44-proposals-list.vue'),
                name: 'CabinetFl44ProposalsList',
                meta: { requiresAuth: true }
            },
            {
                path: 'fl44/purchase_reports',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/fl44/purchase-reports/cabinet-fl44-purchase-reports-list.vue'),
                name: 'CabinetFl44PurchaseReports',
                meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_FL44 }
            },
            {
                path: 'fl44/rating-history',
                component: () => import(/* webpackChunkName: "main" */ '@/components/cabinet/fl44/cabinet-fl44-rating-history.vue'),
                name: 'CabinetFl44RatingHistory',
                meta: { requiresAuth: true }
            },
            {
                path: 'fl44/limits',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/fl44/cabinet-fl44-limits-list.vue'),
                name: 'CabinetFl44LimitsList',
                meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_FL44 }
            },
            {
                path: 'fl223/contracts',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/fl223/cabinet-fl223-contracts-list.vue'),
                name: 'CabinetFl223Contracts',
                meta: { requiresAuth: true }
            },
            {
                path: 'fl223/notices',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/fl223/cabinet-fl223-notices-list.vue'),
                name: 'CabinetFl223Notices',
                meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_FL223 }
            },
            {
                path: 'fl223/proposals',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/fl223/cabinet-fl223-proposals-list.vue'),
                name: 'CabinetFl223ProposalsList',
                meta: { requiresAuth: true }
            },
            {
                path: 'fl223/settings',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/fl223/cabinet-fl223-settings.vue'),
                name: 'CabinetFl223Settings',
                meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_FL223 }
            },
            {
                path: 'commercial/contracts',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/commercial/cabinet-commercial-contracts-list.vue'),
                name: 'CabinetCommercialContracts',
                meta: { requiresAuth: true }
            },
            {
                path: 'commercial/notices',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/commercial/cabinet-commercial-notices-list.vue'),
                name: 'CabinetCommercialNotices',
                meta: { requiresAuth: true, orgRole: OrgRoles.CUSTOMER_COMMERCIAL }
            },
            {
                path: 'commercial/proposals',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/commercial/cabinet-commercial-proposals-list.vue'),
                name: 'CabinetCommercialProposalsList',
                meta: { requiresAuth: true }
            },
            {
                path: 'reliability-report',
                component: () => import(/* webpackChunkName: "cabinet" */ 'themes/views/pages/client-space/supplier/organization-reliability-report/OrganizationReliabilityReport.view.vue'),
                name: 'CabinetOrganizationReliabilityReport',
                meta: { requiresAuth: true }
            },
            {
                path: 'quotation_requests/offers/:cat',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/quotation-requests/cabinet-quotations-list.vue'),
                name: 'CabinetQuotationRequestsOffersList',
                meta: { requiresAuth: true }
            },
            {
                path: 'quotation_requests/requests/:cat',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/quotation-requests/cabinet-quotation-requests-list.vue'),
                name: 'CabinetQuotationRequestsList',
                meta: { requiresAuth: true }
            },
            {
                path: 'addresses',
                component: () => import(/* webpackChunkName: "cabinet" */ '@/components/cabinet/addresses/cabinet-address-list.vue'),
                name: 'CabinetPersonalAddresses',
                meta: { requiresAuth: true }
            }
        ]
    }
];
